import {
  Box,
  Button,
  styled,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useMemo } from "react";

import logo from "../assets/images/abb_logo.svg";
import cart from "../assets/icons/cart.svg";

import { useNavigate } from "react-router-dom";
import { CartPayload } from "../types";
import { useAppSelector } from "../hooks";
import { recount } from "../reducers/products";

import { getResponsivePaddings } from "../utils";
import theme from "../theme";

const HeaderContainer = styled(Box)(() => ({
  height: "72px",
  width: "100vw",

  backgroundColor: "#fff",
  boxShadow: "0px 2px 6px 0px rgba(0, 0, 0, 0.15)",

  position: "fixed",
  top: 0,

  zIndex: 1,
}));

const HeaderContent = styled(Box)(({ theme }) => ({
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  margin: "0 auto",
  padding: "0 96px",
  "& > div": {
    display: "flex",
    alignItems: "center",
  },

  ...getResponsivePaddings(theme),
}));

const CartCounter = styled(Box)(() => ({
  position: "absolute",
  right: "4px",
  top: "4px",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  width: "16px",
  height: "16px",

  background: "#E12E2E",
  borderRadius: "250px",
}));

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const navigate = useNavigate();
  const isResponsive = useMediaQuery(theme.breakpoints.down("md"));

  const _ = useAppSelector(recount);

  const parsedData = useMemo(() => {
    const savedData = localStorage.getItem("Cart");

    const data: CartPayload = savedData ? JSON.parse(savedData) : null;

    return data;
  }, [_]);

  return (
    <HeaderContainer component="nav">
      <HeaderContent>
        <Box>
          <Button
            onClick={() => navigate("/")}
            sx={{ border: 0 }}
          >
            <img alt="ABB Logo" src={logo} />
          </Button>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              minWidth: 0,
              flex: 1,
            }}
          >
            <Box
              sx={{
                height: { xs: "20px", md: "24px" },
                width: "1px",
                bgcolor: "#BABABA",
                mx: { xs: "10px", md: "16px" },
                flexShrink: 0,
              }}
            />
            <Typography
              variant={isResponsive ? "bodySmallWeightMedium" : "bodyMediumWeightRegular"}
              component="h1"
              sx={{
                minWidth: 0,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              Critical Power {isResponsive ? <br /> : " "}Configurator
            </Typography>
          </Box>
        </Box>

        <Button
          onClick={() => navigate("/cart")}
          variant="containedWhite"
          sx={{ position: "relative", minWidth: isResponsive ? "auto" : undefined }}
        >
          {parsedData &&
            (parsedData.items.length > 0 ||
              parsedData.looseItems.length > 0) && (
              <CartCounter>
                <Typography
                  variant="bodySmallWeightMedium"
                  color="common.white"
                >
                  {parsedData.items.length + parsedData.looseItems.length}
                </Typography>
              </CartCounter>
            )}

          {!isResponsive && (
            <Typography variant="bodyMediumWeightMedium">Cart</Typography>
          )}
          <img alt="cart" src={cart} />
        </Button>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
